import React from 'react';
import { BulletIcon } from '@THC/components/Icons/Bullet';
import { MDText } from 'i18n-react';

import cypressIds from 'Components/cypress_ids.json';
import VrmModal from 'Components/pages/VehicleDetailsRedesign/Components/VrmModal/VrmModal';
import ListTable from 'Components/shared/ProTable/ListTable/ListTable';
import type { Vehicle } from 'Types/vehicle';
import { formatDate, formatVehicleName } from 'Utilities/formatters';
import { applyCypressData } from 'Utilities/helpers';

import LocalTexts from './MotModal.texts';

import styles from './MotModal.module.scss';

const LocalT = new MDText(LocalTexts);

type MotModalProps = {
	advisories: string[];
	advisoriesCount: number;
	lastMOTDate: Nullable<string>;
	make: Vehicle['spec']['make'];
	model: Vehicle['spec']['model'];
	onDismissModal?: () => void;
	vrm: Vehicle['vrm'];
};

const MotModal: React.FC<MotModalProps> = ({
	advisories,
	advisoriesCount,
	lastMOTDate,
	make,
	model,
	onDismissModal,
	vrm,
}) => {
	const makeModel = formatVehicleName({ make, model });

	const tableValues = advisories.map((item, index) => ({
		key: `mot-advisory-item-${index}`,
		label: <BulletIcon />,
		value: item,
	}));

	return (
		<VrmModal
			footer={
				<div className={styles.footer}>
					<p className={styles.completedOn}>{LocalT.translate('completedOn', { date: formatDate(lastMOTDate) })}</p>
					<p className={styles.disclaimer}>{LocalT.translate('disclaimer')}</p>
				</div>
			}
			makeModel={makeModel}
			onDismissModal={onDismissModal}
			subtitle={LocalT.translate('advisoriesCount', { count: advisoriesCount })}
			title={LocalT.translate('title')}
			vrm={vrm}
		>
			<ListTable
				omitNils
				className={styles.table}
				labelClassName={styles.labelColumn}
				proTableParams={{
					tableProps: { ...applyCypressData(cypressIds.tables.motModal) },
				}}
				valueClassName={styles.valueColumn}
				values={tableValues}
			/>
		</VrmModal>
	);
};

export default MotModal;
